import React from 'react';

interface FieldElemWrapperProps {
  name: string;
  form: any;
  children: React.ReactNode;
}

export default class FieldElemWrapper extends React.Component<FieldElemWrapperProps> {
    componentDidMount() {
        const { name, form } = this.props;
        form.domFields[name] = true;
        form.recoverClearedField(name);
    }

    componentWillUnmount() {
        const { name, form } = this.props;
        const fieldMeta = form.fieldsStore.getFieldMeta(name);
        if (!fieldMeta.preserve) {
            // after destroy, delete data
            form.clearedFieldMetaCache[name] = {
                field: form.fieldsStore.getField(name),
                meta: fieldMeta,
            };
            form.clearField(name);
        }
        delete form.domFields[name];
    }

    render() {
        return this.props.children;
    }
}
